import {
  getCampagneInCorsoApi,
  getCampagnaVolantiniApi,
} from "../services/api.services";
import { hasNewCheckout } from "./utility";

// ============================================================================
// Volantini di un punto vendita ("Offerte disponibili" della mappa negozi)
// ----------------------------------------------------------------------------
// Incrocio fra le campagne in corso del tenant (campagna/in-corso) e i
// volantini assegnati al punto vendita in ciascuna campagna
// (campagna/volantini, tipo "punto_vendita"). Gli id dei negozi della mappa
// (viewmanager) coincidono con i punto_vendita_id delle API v2.
//
// Il risultato ha la stessa forma dei `volantini` di market/detail, cosi' la
// UI della mappa non cambia. Senza X-Client-Token, o con qualunque errore,
// torna [] e la sezione resta nascosta.
// ============================================================================

const isOk = (res) => res && res.status === 200 && Array.isArray(res.data);

// Le campagne in corso sono le stesse per tutti i negozi: una sola chiamata
// per pagina, condivisa (anche fra richieste concorrenti).
let campaignsPromise = null;
const getCampaigns = () => {
  if (!campaignsPromise) {
    campaignsPromise = getCampagneInCorsoApi()
      .then((res) => (isOk(res) ? res.data : []))
      .catch(() => []);
  }
  return campaignsPromise;
};

// Riga di campagna/volantini -> forma dei volantini di market/detail.
const toStoreFlyer = (v) => ({
  id: v.volantino_id,
  name: v.nome_pubblicazione,
  url: v.link_pubblicazione,
  image: v.thumb_prima_pagina || v.immagine_prima_pagina,
  selloutStart: v.data_inizio_sellout,
  selloutEnd: v.data_fine_sellout,
});

export const getStoreFlyers = async (idMarket) => {
  if (!hasNewCheckout() || !idMarket) return [];

  const campaigns = await getCampaigns();
  const perCampaign = await Promise.all(
    campaigns.map((c) =>
      getCampagnaVolantiniApi({
        campagna_id: c.id,
        tipo: "punto_vendita",
        punto_vendita_id: Number(idMarket),
      })
        .then((res) => (isOk(res) ? res.data : []))
        .catch(() => [])
    )
  );

  // Lo stesso volantino puo' arrivare da piu' campagne: uno solo.
  const seen = new Set();
  return perCampaign
    .flat()
    .filter((v) => {
      if (!v || !v.volantino_id || seen.has(v.volantino_id)) return false;
      seen.add(v.volantino_id);
      return true;
    })
    .map(toStoreFlyer);
};
